import React from 'react';
import classNames from 'classnames';

const ScrollableContainer = React.forwardRef(
  (
    { maxHeight, hidden, dark, className, children, bordered, onScroll },
    ref,
  ) => {
    const style = {
      maxHeight: maxHeight ? `${maxHeight}px` : undefined,
    };

    const styleName = classNames('ScrollableContainer', {
      'ScrollableContainer--dark': dark,
      'ScrollableContainer--hidden': hidden,
      'ScrollableContainer--bordered': bordered,
      [className]: !!className,
    });

    return (
      <div
        ref={ref}
        onScroll={onScroll}
        style={style}
        className={styleName}
        children={children}
      />
    );
  },
);

ScrollableContainer.defaultProps = {
  maxHeight: 200,
  dark: true,
  hidden: false,
};

export default ScrollableContainer;
